import {differenceInHours} from 'date-fns'
import {DateString, FilterOption} from 'store/types'
import {MAX_HOURS} from './Lists/TableLogList/constants'

export const checkRemainingTime = (createdAt: DateString | undefined) => {
  if (!createdAt) return false
  const differenceHours = differenceInHours(new Date(), new Date(createdAt))
  return Boolean(differenceHours > MAX_HOURS)
}

export const mappingToViews = (
  ids: (number | string)[],
  options: FilterOption[] | null,
  key: keyof FilterOption,
): FilterOption[] => (options ? options.filter(item => ids.includes(item[key])) : [])

export const mappingToAPI = <T>(items: T[], key: keyof T): T[keyof T][] =>
  items.map(item => item[key])
